import { Box, Typography } from '@mui/material'
import React from 'react'

interface LabelProps {
    imageUrl: string
    text: string
    textColor: string
    textBackgroundColor: string
}

const VodItemLabel = ({ label }: { label: LabelProps }) => {
    const containerStyle = {
        padding: '8px',
        borderRadius: '8px',
        position: 'relative',
        width: 'max-content',
    }

    return label?.imageUrl ? (
        <img src={label.imageUrl} alt={label.text} />
    ) : (
        <>
            {label && label.text && (
                <Box
                    bgcolor={
                        label?.textBackgroundColor
                            ? `#${label?.textBackgroundColor.replace(
                                  /[^0-9]/g,
                                  ''
                              )}`
                            : 'primary.main'
                    }
                    sx={containerStyle}>
                    <Typography
                        color={label.textColor || 'white'}
                        fontSize="16px"
                        fontWeight="bold">
                        {label.text.toUpperCase()}
                    </Typography>
                </Box>
            )}
        </>
    )
}

export { VodItemLabel }
